import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BackButton, ErrorCodesProviderForm } from 'components';
import { putProviderCredsErrorCodesService } from 'services/admin/providerService';
import { setProviderErrorCodeToCreate } from 'redux/slices/admin/providerSlice';
import { Grid } from '@mui/material';

function CreateErrorCodesScreen() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { current, providerErrorCodeToCreate } = useSelector(store => store.providers)
    useEffect(() => {
        return () => {
            dispatch(setProviderErrorCodeToCreate(null));
        }
    }, [])

    return (
        <>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mt={2}
            >
                <div>
                    <BackButton click={() => navigate(-1)} />
                </div>
                <div className="container-title">
                    <div className="title">Proveedor</div>
                    <div className="subtitle">{current.container_name}</div>
                </div>
                <div style={{ width: "170px" }}></div>
            </Grid>
            <ErrorCodesProviderForm
                title={"Cancelar"}
                defaultValues={{
                    hebeExceptionCode: "",
                    externalExceptionCode: providerErrorCodeToCreate ? providerErrorCodeToCreate : ""
                }}
                goBack={() => {
                    navigate(-1);
                }}
                submit={(data) => {
                    data['connectorName'] = current.host;
                    putProviderCredsErrorCodesService(data).then((result) => {
                        navigate(-1);
                    }).catch((e) => {
                        console.log(e);
                        navigate(-1);
                    });
                }}
            />
        </>
    );
}

export default CreateErrorCodesScreen;